import { getLink } from "@/auth/lib";
import { useCallback, useState } from "react";

interface Options {
  onError?: (message: string) => void;
  onSuccess?: () => void;
}

export function useGetLink({ onError, onSuccess }: Options = {}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();

  const requestLink = useCallback(
    async (email: string) => {
      if (email.trim() === "") {
        setError("Please enter an email.");
        return;
      }

      setError(undefined);
      setLoading(true);
      await getLink({ email })
        .then(() => {
          if (onSuccess) {
            onSuccess();
          }
        })
        .catch((e) => {
          setError(e.message);
          if (onError) {
            onError(e.message);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [onSuccess, onError],
  );

  return { requestLink, loading, error };
}
